import { render, staticRenderFns } from "./IncidencesList.vue?vue&type=template&id=636645b3&"
import script from "./IncidencesList.vue?vue&type=script&lang=js&"
export * from "./IncidencesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports